// 2026-06-20 (user request) — SATU fungsi perhitungan progress pembayaran untuk
// Ringkasan, Keuangan, Cash Flow, chart, dan export. Mirror persis dari backend
// `utils/computation.compute_payment_progress` — jangan ubah salah satu tanpa
// mengubah pasangannya.
//
// Dua metrik TERPISAH (jangan dicampur):
//   1) Penerimaan terhadap Nilai Proyek — dasar: Nilai Kontrak → fallback
//      Total Nilai WO → Total Nilai VO (label menyebut dasar).
//   2) Pelunasan Invoice — diterima ÷ total ditagihkan.
// Pembulatan standar (1 desimal). Dasar kosong → pct/remaining null
// (UI menampilkan "Belum ada dasar perhitungan"). Penerimaan melebihi dasar
// TIDAK di-clamp — tampil nilai sebenarnya + flag over (warning).

export function computePaymentProgress({ contractValue = 0, woValueSum = 0, voValueSum = 0, invoicedTotal = 0, receivedTotal = 0 } = {}) {
  const cv = Number(contractValue) || 0;
  const wo = Number(woValueSum) || 0;
  const vo = Number(voValueSum) || 0;
  const invoiced = Number(invoicedTotal) || 0;
  const received = Number(receivedTotal) || 0;

  let basisValue = 0, basisLabel = null;
  if (cv > 0) { basisValue = cv; basisLabel = "Nilai Kontrak"; }
  else if (wo > 0) { basisValue = wo; basisLabel = "Total Nilai WO"; }
  else if (vo > 0) { basisValue = vo; basisLabel = "Total Nilai VO"; }

  let receiptPct = null, receiptRemaining = null, receiptOver = false;
  if (basisLabel) {
    receiptPct = Math.round((received / basisValue) * 1000) / 10;
    receiptRemaining = Math.round((basisValue - received) * 100) / 100;
    receiptOver = receiptRemaining < 0;
  }

  let invoiceSettlementPct = null, invoiceSettlementRemaining = null, invoiceOver = false;
  if (invoiced > 0) {
    invoiceSettlementPct = Math.round((received / invoiced) * 1000) / 10;
    invoiceSettlementRemaining = Math.round((invoiced - received) * 100) / 100;
    invoiceOver = invoiceSettlementRemaining < 0;
  }

  return {
    basisValue, basisLabel,
    receiptPct, receiptRemaining, receiptOver,
    invoicedTotal: invoiced,
    invoiceSettlementPct, invoiceSettlementRemaining, invoiceOver,
    receivedTotal: received,
  };
}
